import { Category, GQL_ID } from '@@types'
import { gql, useQuery } from '@apollo/client'

type Query = {
  category: Category
}

interface BasicProps {
  shop_id: GQL_ID
}

interface CategoryIdProp extends BasicProps {
  id: GQL_ID
  slug?: string
}

interface CategorySlugProp extends BasicProps {
  slug?: string
  id?: never
}
type Variables = CategoryIdProp | CategorySlugProp

export const GQL_QUERY_SINGLE_CATEGORY = gql`
  query category ($shop_id: ID!, $id: ID, $slug: String) {
    category(shop_id: $shop_id, id: $id, slug: $slug) {
      id
      name
      slug
      parent {
        id
        slug
        name
      }
      altIcon {
        url
      }
    }
  }
`

export const useFetchSingleCategory = ({ shop_id, id, slug}: Variables) => {
  const { data, loading, error, refetch } = useQuery<Query, Variables>(GQL_QUERY_SINGLE_CATEGORY, {
    variables: {
      shop_id,
      id,
      slug
    }
  })

  const category = data?.category

  return {
    category,
    data,
    loading,
    error,
    refetch
  }
}